import { useEffect } from "react";

// Substitui o pacote "react-messenger-customer-chat" (peer dep presa ao React <=16).
// Reimplementação local do embed oficial do Facebook Customer Chat Plugin:
// https://developers.facebook.com/docs/messenger-platform/discovery/customer-chat-plugin
function removeElementByIds(ids) {
  ids.forEach((id) => {
    const element = document.getElementById(id);
    if (element && element.parentNode) {
      element.parentNode.removeChild(element);
    }
  });
}

function loadSdk(language) {
  removeElementByIds(["facebook-jssdk", "fb-root"]);
  delete window.FB;

  if (document.getElementById("facebook-jssdk")) {
    return;
  }

  const firstScript = document.getElementsByTagName("script")[0];
  const script = document.createElement("script");
  script.id = "facebook-jssdk";
  script.src = `https://connect.facebook.net/${language}/sdk/xfbml.customerchat.js`;
  firstScript.parentNode.insertBefore(script, firstScript);
}

export default function MessengerCustomerChat({
  pageId,
  appId,
  language = "en_US",
  version = "2.11",
  autoLogAppEvents = true,
  xfbml = true,
}) {
  useEffect(() => {
    window.fbAsyncInit = function fbAsyncInit() {
      window.FB.init({
        appId,
        autoLogAppEvents,
        xfbml,
        version: `v${version}`,
      });
    };

    loadSdk(language);

    return () => {
      if (window.FB !== undefined) {
        window.FB.CustomerChat.hide();
      }
    };
  }, [pageId, appId, language, version, autoLogAppEvents, xfbml]);

  return (
    <div
      key={pageId}
      dangerouslySetInnerHTML={{
        __html: `<div class="fb-customerchat" page_id="${pageId}"></div>`,
      }}
    />
  );
}
